export default __webpack_public_path__ + "static/media/81.23a9be3e.png";